import React, { useState } from 'react';
import { ReactComponent as IconQuickSelect } from 'components/StoreSelector/assets/icon_enter.svg';
import { ReactComponent as IconQuickSelectHover } from 'components/StoreSelector/assets/icon_enter_hover.svg';
import Icon from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import { noop } from 'lodash-es';

interface Props {
  onClick?: () => void;
}

const QuickSelectButton = React.memo((props: Props) => {
  const { onClick } = props;

  const [isHover, setIsHover] = useState(false);
  const { t } = useTranslate();
  return (
    <span
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onFocus={noop}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      <Tooltip title={t('storeSelector.切换店铺')} mouseEnterDelay={0.5}>
        {isHover ? (
          <Icon component={IconQuickSelectHover} size={18} />
        ) : (
          <Icon component={IconQuickSelect} size={18} />
        )}
      </Tooltip>
    </span>
  );
});

export default QuickSelectButton;
